import axios from 'axios';
import { POWER_BI_PARAMS } from './constants';

export const powerBiParamsRequest = (pointOfSaleGuid) => axios.get(POWER_BI_PARAMS(pointOfSaleGuid));
